import { hydrateWidgets } from '@utils';
import { PangaeaBanner } from '../../widgets/DVWebNodePangaeaBanner';
hydrateWidgets(PangaeaBanner);
